import {TransactionType} from '../../master/extract/extract.model';

export class ResponseModel{


	dataTransacao: Date;
	tipoMovimentacao: string;
	descricao: string;
	codigoDocumento: string;
	valor: string;
	saldo: string;

	constructor(dataTransacao: Date, tipoMovimentacao: string, descricao: string, codigoDocumento: string, valor: string, saldo: string) {
		this.dataTransacao = dataTransacao;
		this.tipoMovimentacao = tipoMovimentacao;
		this.descricao = descricao;
		this.codigoDocumento = codigoDocumento;
		this.valor = valor;
		this.saldo = saldo;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/export-buttons/response.model.ts